import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/base/SectionHeading";
import { services } from "@/mocks/home";

export default function Services() {
  return (
    <section id="services" className="border-y border-background-200 bg-background-100/50 py-16 md:py-24">
      <div className="mx-auto w-full max-w-shell px-4 md:px-6">
        <Reveal>
          <SectionHeading
            eyebrow="平台服务"
            title="黑料平台服务方案，按角色选用"
            description="浏览、创作与合作走的是不同通道。先确认自己属于哪一类，再选对应的服务即可。"
            align="center"
          />
        </Reveal>

        <div className="mt-12 grid grid-cols-1 gap-5 md:grid-cols-3">
          {services.map((service, index) => {
            const isHighlight = service.highlight;
            return (
              <Reveal key={service.name} delay={index * 80}>
                <article
                  className={`relative flex h-full flex-col rounded-lg border p-6 md:p-7 ${
                    isHighlight
                      ? "border-primary-300 bg-background-50 ring-1 ring-primary-200"
                      : "border-background-200 bg-background-50"
                  }`}
                >
                  {isHighlight ? (
                    <span className="absolute right-5 top-5 rounded-full bg-accent-100 px-3 py-1 text-xs font-semibold text-accent-900">
                      推荐
                    </span>
                  ) : null}

                  <span
                    className={`flex h-12 w-12 items-center justify-center rounded-md ${
                      isHighlight
                        ? "bg-primary-500 text-background-50"
                        : "bg-secondary-100 text-secondary-700"
                    }`}
                  >
                    <i className={`${service.icon} text-xl`} />
                  </span>

                  <h3 className="mt-5 font-heading text-lg font-bold text-foreground-950">
                    {service.name}
                  </h3>
                  <div className="mt-2 flex items-baseline gap-2">
                    <span className="font-heading text-xl font-bold text-primary-600">
                      {service.price}
                    </span>
                    <span className="text-xs text-foreground-500">{service.unit}</span>
                  </div>
                  <p className="mt-4 text-sm leading-relaxed text-foreground-600">
                    {service.desc}
                  </p>

                  <ul className="mt-6 flex-1 space-y-3">
                    {service.points.map((point) => (
                      <li key={point} className="flex items-start gap-2 text-sm text-foreground-700">
                        <i className="ri-check-line mt-0.5 text-primary-600" />
                        <span>{point}</span>
                      </li>
                    ))}
                  </ul>

                  <a
                    href="#faq"
                    className={`mt-7 inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md px-5 py-3 text-sm font-semibold transition-colors ${
                      isHighlight
                        ? "bg-primary-500 text-background-50 hover:bg-primary-600"
                        : "border border-background-300 text-foreground-800 hover:border-primary-300 hover:text-primary-600"
                    }`}
                  >
                    了解方案
                    <i className="ri-arrow-right-line" />
                  </a>
                </article>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}